module.exports = __webpack_public_path__ + "media/assets/icons/search-bluegray-500-ae67d81fb0a8850ff6d26f74c854011d.svg";